<template>
  <div class="market-contract-list-v2-embed-compact">
    <div class="market-contract-list-v2-embed-compact__title">{{ items[0].marketName }}</div>
    <div
      v-for="(item, index) in items"
      :key="`market-contract-list-v2-embed-compact-${index}-${item.marketId}`"
      class="market-contract-info-v2__widget-item"
    >
      <market-contract-info-v2
        :image="item.image"
        :link="itemLink(item)"
        :trackingContext="trackingContext"
        :layout="MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK"
      >
        <template v-slot:content>
          <div class="market-contract-info-v2__row">
            <div
              class="market-contract-info-v2__value-light market-contract-list-v2-embed-compact__contract-name"
              v-contract-name
            >
              {{ item.contractName }}
            </div>
            <div class="market-contract-info-v2__value-light-darker market-contract-info-v2--mono">
              <market-change-price
                :price="item.price"
                :lastClosePrice="item.lastClosePrice"
              ></market-change-price>
              <template v-if="item.hasLastTradePrice">
                <animated-number
                  class="market-contract-list-v2-embed-compact__item-price-box"
                  :value="item.priceAsCents"
                ></animated-number>
              </template>
              <template v-else>
                <span class="market-contract-list-v2-embed-compact__item-price-box">NEW</span>
              </template>
            </div>
          </div>
        </template>
      </market-contract-info-v2>
    </div>
  </div>
</template>

<script src="./market-contract-list-v2-embed-compact.js"></script>
<style src="./market-contract-list-v2-embed-compact.scss" lang="scss"></style>
